import { ETenderRequirementType } from 'types/tender/tenderRequirements'
import { DocumentRequirementItem } from 'pages/tender/lot/document-requirement-item'

export const DocumentRequirementsSection = ({
  isSubmissionTimePassed,
}: {
  isSubmissionTimePassed: boolean
}) => {
  return (
    <>
      <DocumentRequirementItem
        type={ETenderRequirementType.GENERAL}
        isSubmissionTimePassed={isSubmissionTimePassed}
      />
      <DocumentRequirementItem
        type={ETenderRequirementType.SPECIAL}
        isSubmissionTimePassed={isSubmissionTimePassed}
      />
    </>
  )
}
